import { render, staticRenderFns } from "./DuelChallenge_Actions_Unauthenticated.vue?vue&type=template&id=3b63fd6d&"
import script from "./DuelChallenge_Actions_Unauthenticated.vue?vue&type=script&lang=js&"
export * from "./DuelChallenge_Actions_Unauthenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports